import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Button, IconButton } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(6),
  },
  navigationButton: {
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.8,
    },
  },
  navigationButtonDisabled: {
    color: '#94A3B8',
  },
  navigationButtonEnabled: {
    color: '#1E293B',
  },
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  pageButton: {
    width: 28,
    height: 28,
    minWidth: 28,
    borderRadius: 8,
    fontSize: 14,
    color: '#64748B',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(67, 97, 238, 0.08)',
    },
  },
  activePageButton: {
    color: 'white',
    backgroundColor: '#4361EE',
    '&:hover': {
      backgroundColor: '#4361EE',
    },
  },
}));

const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
  const classes = useStyles();

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div className={classes.root}>
      <Button
        startIcon={<ArrowBackIcon />}
        disabled={currentPage === 1}
        onClick={handlePrevious}
        onMouseDown={(e) => e.preventDefault()}
        className={`${classes.navigationButton} ${
          currentPage === 1
            ? classes.navigationButtonDisabled
            : classes.navigationButtonEnabled
        }`}
        disableRipple
        disableFocusRipple
      >
        Previous
      </Button>
      <div className={classes.paginationContainer}>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <IconButton
            key={page}
            onClick={() => onPageChange(page)}
            onMouseDown={(e) => e.preventDefault()}
            className={`${classes.pageButton} ${
              page === currentPage ? classes.activePageButton : ''
            }`}
            disableRipple
            disableFocusRipple
            size="large">
            {page}
          </IconButton>
        ))}
      </div>
      <Button
        endIcon={<ArrowForwardIcon />}
        disabled={currentPage === totalPages}
        onClick={handleNext}
        onMouseDown={(e) => e.preventDefault()}
        className={`${classes.navigationButton} ${
          currentPage === totalPages
            ? classes.navigationButtonDisabled
            : classes.navigationButtonEnabled
        }`}
        disableRipple
        disableFocusRipple
      >
        Next
      </Button>
    </div>
  );
};

export default BlogPagination;
